import { createSlice } from "@reduxjs/toolkit";
import { getPaymentMethods } from "./paymentMethodsAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  paymentMethods: [],
  latestRequestId: null,
};

const paymentMethodsSlice = createSlice({
  name: "paymentMethods",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentMethods.pending, (state, action) => {
        state.loading = true;
        state.paymentMethods = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getPaymentMethods.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.paymentMethods = action.payload;
        state.error = null;
      })
      .addCase(getPaymentMethods.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default paymentMethodsSlice.reducer;
